export default __webpack_public_path__ + "static/media/ies_Toljy.94a0d851.png";